<template>
  <div class="card">
    <div class="card-body">
      <b-row>
        <b-col xl="3" lg="3" md="6" sm="12" class="pt-1">
          <market-place-component @input="handleMarketplace"/>
        </b-col>
      </b-row>
    </div>
  </div>

</template>

<script>
import MarketPlaceComponent from "../../../components/widgets/MarketPlaceComponent";

export default {
  name: "CatalogFilter",
  components: {MarketPlaceComponent},
  data() {
    return {
      fulfilment: null,
      dateRange: null,
    }
  },
  methods: {
    handleMarketplace(e) {
      this.$emit('marketplace', e)
    },
  }
}
</script>

<style scoped>

</style>